import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Asset } from 'src/app/state-management';

@Component({
    selector: 'app-asset',
    templateUrl: './asset.component.html',
    styleUrls: ['./asset.component.scss'],
    standalone: false
})
export class AssetComponent implements OnInit, OnChanges {
  @Input() assets: Asset[];
  @Input() problemId: number;
	@Input() isCityworksRequest: boolean;
  @Output() DeleteAssetEmitter = new EventEmitter<Asset>();
  @Output() TagAssetEmitter = new EventEmitter<Asset>();

  displayAssets: Asset[];
  problemAssets: Asset[];

	constructor() {}

	ngOnInit() {}

  ngOnChanges(changes: SimpleChanges){
    if(changes.assets){
      if(changes.assets.currentValue.length > 0){
        this.problemAssets = this.getAssets();
      }
    }
  }

  delete(asset: Asset) {
    this.DeleteAssetEmitter.emit(asset);
  }

  getAssets() {
		return this.assets.filter((a) => a.problem_RefId === this.problemId);
  }

  tagAssetGT() {
    this.TagAssetEmitter.emit();
  }
}
